<template>
  <div class="landing__container">
    <div class="landing__section">
      <div class="landing__section-container">
        <div class="landing__section-row">
          <div class="landing__section-col-left">
            <section-left/>
          </div>
          <div class="landing__section-col-right">
            <section-right/>
          </div>
        </div>
        <div class="landing__section-row">
          <div class="landing__section-col">
            <offer-button></offer-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionLeft from './SectionLeft';
import SectionRight from './SectionRight';
import OfferButton from './OfferButton';

export default {
  name: 'intro',
  components: {
    SectionLeft,
    SectionRight,
    OfferButton,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../main.scss';

.landing__container {
  @extend .container-fluid;
  padding: 0px;
}

.landing__section {
  @extend .jumbotron;
  @extend .jumbotron-fluid;
  margin: 0 auto;

  &-container {
    @extend .container-fluid;
  }

  &-row {
    @extend .row;
    @extend .align-items-center;
  }

  &-col {
    @extend .col;
    @extend .text-center;
  }

  &-col-left {
    @extend .col;
  }

  &-col-right {
    @extend .col;
  }
}
</style>



// WEBPACK FOOTER //
// Intro.vue?749d9629